@if (!!info) {
    <div class="content-container">
        <h1>{{ info['title' + crtLang.toUpperCase()] }}</h1>
        <h6>{{ info.publicationDate | date }}</h6>
        <div class="btn-bar">
            <button class="btn btn-link me-auto" [appHasAnyPermission]="[PermissionKeys.gestionCommunication]"
                    [routerLink]="['../manage/' + infoId]">
                <fa-icon class="me-2" [icon]="icons.pen"></fa-icon>
                <span translate="common.manageInfo"></span>
            </button>

            <div class="right-bar">
                <button class="btn btn-outline-secondary"
                        (click)="back()"
                        translate="common.back">
                </button>

                @if (hasPreviousInformation()) {
                    <button class="btn btn-primary"
                            (click)="previousInformation()"
                            translate="common.previous">
                    </button>
                }

                @if (hasNextInformation()) {
                    <button class="btn btn-primary"
                            (click)="nextInformation()"
                            translate="common.next">
                    </button>
                }
            </div>
        </div>

        <!-- Content -->
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="no-border-radius area-link"
                     [innerHTML]="info['content' + crtLang.toUpperCase()] | urlTextToLink">
                </div>
            </div>

            @if (!!info.illustrationUrl) {
                <div class="col-12 col-lg-6">
                    <div class="text-center">
                        <a href="{{ info.illustrationUrl }}" target="_blank" rel="noopener">
                            <img class="rounded mw-100" [src]="info.illustrationUrl"
                                 alt="{{ 'communicationChannel.information.illustration' | translate }}"/>
                        </a>
                    </div>
                </div>
            }
        </div>
    </div>
}

<!-- Documents -->
@if (!!info) {
    <app-document-view #documentListComponent
                       [documentManagementType]="DocumentManagementTypeEnum.Information"
                       [canManage]="canManage"
                       [id]="info.id"></app-document-view>
}
